import { render, staticRenderFns } from "./we-series-view.vue?vue&type=template&id=4d5e5112&"
import script from "./we-series-view.vue?vue&type=script&lang=js&"
export * from "./we-series-view.vue?vue&type=script&lang=js&"
import style0 from "./we-series-view.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports